export default __webpack_public_path__ + "static/media/covenantsofdeath.e79d248b.png";